module.exports = __webpack_public_path__ + "static/turquia-022.thumb-9bafb435fe8b5d1ce00764c65297b7ec.jpg";